<template>
  <div
    class="course-section-box show-flex-box-c"
    @click="clickThisSectionInfo()"
  >
    <dl class="show-flex-box-r">
      <dt class="show-flex-box-r">
        <div class="show-flex-box-c">
          <strong :class="{'show-flex-box-r': true, 'last-watch': isPlayingSectionId == sectionCourseInfo.id}">
          <!-- <strong class="show-flex-box-r"> -->
            <strong class="hide-line2">{{ sectionCourseInfo.title }}</strong>
            <em v-if="isPlayingSectionId == sectionCourseInfo.id"></em>
          </strong>
          <h3 class="show-flex-box-r">
            <span class="show-flex-box-r" @click.stop="showCourseSectionDescription()">
              <span>介绍</span>
              <em :class="{ 'show-course-description': isShowSectionDescription }"></em>
            </span>
            <strong>课程时长 {{ dealShowTime(sectionCourseInfo.media_data) }}</strong>
            <!-- <h5 class="show-flex-box-r show-flex-center" v-if="lastViewSectionId == sectionCourseInfo.id && isPlayingSectionId != lastViewSectionId">
              <span>上次看到</span>
            </h5> -->
          </h3>
        </div>
      </dt>
      <!-- <dd class="circle-progress-bar">
        <circle-progress :percentage="sectionCourseInfo.studyDegree || 0" />
      </dd> -->
    </dl>
    <h3 class="show-flex-box-r b-top" v-show="isShowSectionDescription">
      <span>{{ sectionCourseInfo.summary }}</span>
    </h3>
    <em v-if="!sectionCourseInfo.can_view && !!sectionCourseInfo.is_audition"></em>
  </div>
</template>

<script>
// import circleProgress from '@/components/basic/circular_progress_bar_comp';
  import { formatSeconds } from '@/utils/utils';

export default{
  components: {
    // circleProgress
  },
  props: {
    courseDetail: [Object],
    sectionCourseInfo: [Object],
    lastViewSectionId: [Number, String],
    isPlayingSectionId: [Number, String],
  },
  data() {
    return {
      isShowSectionDescription: false
    };
  },
  mounted() {},
  methods: {
    dealShowTime(mediaData){
      if(!mediaData) {
        return
      }
      
      let duration = mediaData.duration;
      let timeModel = formatSeconds(duration);
      let showText = '';
      
      showText = timeModel.h ? (showText + timeModel.h + ':') : '';
      showText = timeModel.m ? (showText + timeModel.m + ':') : '00:';
      showText = timeModel.s ? (showText + timeModel.s) : '00';

      return showText;
    },
    // 点击 ‘介绍’ 按钮
    showCourseSectionDescription() {
      this.isShowSectionDescription = !this.isShowSectionDescription;
    },
    // 点击该课程小节
    clickThisSectionInfo(){
      const CourseSectionInfo = this.sectionCourseInfo;

      const canView = this.courseDetail.can_view;
      const isAudition = CourseSectionInfo.is_audition;
      const isFree = this.courseDetail.is_free;

      const sendInfo = {
        canView: canView,
        isFree: isFree,
        isAudition: isAudition,
        auditionTime: CourseSectionInfo.audition_time,
        courseSectionId: CourseSectionInfo.id,
        videoType: CourseSectionInfo.type,
        logoUrl: CourseSectionInfo.logo_url && CourseSectionInfo.logo_url.o || '',
        mediaUrl: CourseSectionInfo.media_url,
      };

      if (canView || isAudition) { // 可以看 / 可以试看
        this.watchThisCourseSectionVideo(sendInfo);
      } else {
        if (isFree) {
          this.watchThisCourseSectionVideo(sendInfo);
        } else {
          this.sendClickEvent();
        }
      }
    },
    sendClickEvent() {
      let sendInfo= {
        id: this.sectionCourseInfo.id,
        type: 'buy',
      };
      
      this.$emit('clickSection', sendInfo);
    },
    watchThisCourseSectionVideo(sendInfo){
      this.$emit('watchThisSection', sendInfo);
    },

  },
  watch: {}
};
</script>

<style lang="less">
.course-section-box{
  position: relative;
  width: 100%;
  border-radius: 0.08rem;
  overflow: hidden;
  background: #FFFFFF;
  > dl{
    box-sizing: border-box;
    // padding: 0.16rem 0.2rem 0.16rem 0.1rem;
    padding: 0.16rem 0.2rem 0.16rem 0.24rem;
    width: 100%;
    align-items: center;
    // box-shadow: 0px 0.04rem 0.12rem 0.04rem rgba(196, 200, 206, 0.2);
    > dt {
      width: 0;
      flex-grow: 1;
      > div{
        width: 100%;
        > strong{
          position: relative;
          margin-bottom: 0.12rem;
          > strong{
            word-break: break-all;
            font-size: 0.15rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            // font-weight: 500 !important;
            color: #333333;
            line-height: 0.21rem;
          }
          > em{
            // display: none;
            position: absolute;
            top: 0.03rem;
            left: -0.14rem;
            width: 0.1rem;
            height: 0.14rem;
            z-index: 99;
            flex-shrink: 0;
            background: url('../../assets/course/play_icon.png') center center no-repeat;
            background-size: 100% 100%;
          }
        }
        > .last-watch{
          > strong{
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #05BE00;
          }
          // > em{
          //   display: block;
          // }
        }
        > h3{
          width: 100%;
          align-items: center;
          > span{
            align-items: center;
            margin-right: 0.2rem;
            > span {
              margin-right: 0.04rem;
              font-size: 0.12rem;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #999999;
              line-height: 0.16rem;
            }
            > em {
              width: 0.08rem;
              height: 0.04rem;
              background: url('../../assets/course/expend_more_icon.png') center center no-repeat;
              background-size: 100% 100%;
              flex-shrink: 0;
              transition: all 0.2s ease-in-out;
            }
            > .show-course-description {
              transition: all 0.2s ease-in-out;
              transform: rotate(180deg);
            }
          }
          > strong{
            font-size: 0.12rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
            line-height: 0.16rem;
          }
          > h5{
            width: 0.52rem;
            height: 0.16rem;
            margin-left: 0.04rem;
            flex-shrink: 0;
            background: rgba(5, 190, 0, 0.1);
            border-radius: 0.08rem;
            > span{
              font-size: 0.1rem;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #05BE00;
              line-height: 0.14rem;
            }
          }
        }
      }
    }
    > .circle-progress-bar {
      flex-shrink: 0;
      width: 0.44rem;
      height: 0.44rem;
      margin-left: 0.16rem;
    }
  }
  > h3{
    // box-sizing: border-box;
    padding-top: 0.12rem;
    padding-bottom: 0.16rem;
    margin: 0 0.16rem;
    // width: 100%;
    > span{
      font-size: 0.12rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 0.16rem;
    }
  }
  > em {
    position: absolute;
    top: 0;
    right: 0;
    width: 0.36rem;
    height: 0.36rem;
    flex-shrink: 0;
    background: url('../../assets/course/can_listen_icon2.png') center center no-repeat;
    background-size: 100% 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/course/new_section_course_comp.vue